import { useIntl } from '@capsicum/common';
import { Divider, GenericDrawer } from '@capsicum/common-web';
import { useBuySellButtons } from '@capsicum/socios-core-web';
import styled from 'styled-components';

export type BuyFanTokensDrawerProps = {
	amount: string;
	closeModal: () => void;
	description: string;
	partnerCurrencyId?: string;
	testID: string;
	title: string;
	walletAmount: string;
};

export const BuyFanTokensDrawer = ({
	amount,
	closeModal,
	description,
	partnerCurrencyId,
	testID,
	title,
	walletAmount
}: BuyFanTokensDrawerProps) => {
	const { $t } = useIntl();
	const { buy } = useBuySellButtons(partnerCurrencyId || '');

	return (
		<GenericDrawer
			buttonText={$t('marketplace.buyFanTokens')}
			description={description}
			isButtonFullWidth
			isButtonOnRow={false}
			secondaryActionButtonText={$t('marketplace.gotIt')}
			testID={testID}
			title={title}
			onButtonPress={() => {
				buy();
				closeModal();
			}}
			onSecondaryActionOnButtonPress={closeModal}
		>
			<S.UserAmount>
				<S.UserAmountText>{$t('marketplace.tokenBalance.yourBalance')}</S.UserAmountText>
				<S.UserAmountValue>{walletAmount}</S.UserAmountValue>
			</S.UserAmount>
			<S.StyledDivider orientation="horizontal" />
			<S.AmountNeededWrapper>
				<S.StyledText>{$t('marketplace.tokenBalance.amountNeeded')}</S.StyledText>
				<S.StyledText>{amount}</S.StyledText>
			</S.AmountNeededWrapper>
		</GenericDrawer>
	);
};

namespace S {
	export const UserAmountText = styled.div`
		${({ theme }) => theme.fonts.text.text5};
		color: ${({ theme }) => theme.colors.text.main.enabled};
	`;

	export const UserAmountValue = styled.div`
		${({ theme }) => theme.fonts.text.text5};
		color: ${({ theme }) => theme.colors.text.destructive.enabled};
	`;

	export const UserAmount = styled.div`
		display: flex;
		padding: ${({ theme }) => `${theme.spacings.xxsmall} ${theme.spacings.small}`};
		background-color: ${({ theme }) => theme.colors.backgrounds.main.unselected};
		${({ theme }) => theme.border.radius.medium}
		margin-top: ${({ theme }) => theme.spacings.small};
		flex-direction: row;
		justify-content: space-between;
	`;

	export const StyledDivider = styled(Divider)`
		margin: ${({ theme }) => theme.spacings.small} 0;
	`;

	export const AmountNeededWrapper = styled.div`
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		padding: ${({ theme }) => theme.spacings.xsmall} 0;
		margin-bottom: ${({ theme }) => theme.spacings.small};
	`;

	export const StyledText = styled.div`
		${({ theme }) => theme.fonts.text.text1};
		color: ${({ theme }) => theme.colors.text.main.enabled};
	`;
}
